import AppNetworkPeople from './AppNetworkPeopleSearch';

export default AppNetworkPeople;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetworkPeopleSearch/index.ts